"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOtherBrandsAvailableModal = exports.getContactDetailsCheckEndpoint = exports.getTotalEarlySettlementContentEndpoint = exports.getAddressSectionContentEndpoint = exports.getContactSectionContentEndpoint = exports.getDashboardMarketingCardEndpoint = exports.getMyRequestEndpoint = exports.getNoConnectionNotificationEndpoint = exports.getNavigationBarEndpoint = exports.getRegisterPageEndpoint = exports.getMyProfileContentEndpoint = exports.getFaqPrivateEndpoint = exports.getFaqPublicEndpoint = exports.getIconFooterEndpoint = exports.getLandingPageTeaserEndpoint = exports.getLegalFooterEndpoint = exports.FetchContentError = void 0;
var FetchContentError;
(function (FetchContentError) {
    FetchContentError["DEFAULT_ERROR"] = "DEFAULT_ERROR";
})(FetchContentError || (exports.FetchContentError = FetchContentError = {}));
function getContentEndpoint(locale, brand, contentType) {
    return `/${brand}/${locale}/${contentType}.json`;
}
const getLegalFooterEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "legal-footer");
};
exports.getLegalFooterEndpoint = getLegalFooterEndpoint;
const getLandingPageTeaserEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "landing-page-teaser");
};
exports.getLandingPageTeaserEndpoint = getLandingPageTeaserEndpoint;
const getIconFooterEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "icon-footer");
};
exports.getIconFooterEndpoint = getIconFooterEndpoint;
const getFaqPublicEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "faq");
};
exports.getFaqPublicEndpoint = getFaqPublicEndpoint;
const getFaqPrivateEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "faq-private");
};
exports.getFaqPrivateEndpoint = getFaqPrivateEndpoint;
const getMyProfileContentEndpoint = (local, brand) => {
    return getContentEndpoint(local, brand, "my-profile-content");
};
exports.getMyProfileContentEndpoint = getMyProfileContentEndpoint;
const getRegisterPageEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "register-page");
};
exports.getRegisterPageEndpoint = getRegisterPageEndpoint;
const getNavigationBarEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "navigation-bar");
};
exports.getNavigationBarEndpoint = getNavigationBarEndpoint;
const getNoConnectionNotificationEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "no-connection-notification");
};
exports.getNoConnectionNotificationEndpoint = getNoConnectionNotificationEndpoint;
const getMyRequestEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "my-request");
};
exports.getMyRequestEndpoint = getMyRequestEndpoint;
const getDashboardMarketingCardEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "dashboard-marketing-card");
};
exports.getDashboardMarketingCardEndpoint = getDashboardMarketingCardEndpoint;
const getContactSectionContentEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "contact-section-content");
};
exports.getContactSectionContentEndpoint = getContactSectionContentEndpoint;
const getAddressSectionContentEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "address-section-content");
};
exports.getAddressSectionContentEndpoint = getAddressSectionContentEndpoint;
const getTotalEarlySettlementContentEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "total-early-settlement");
};
exports.getTotalEarlySettlementContentEndpoint = getTotalEarlySettlementContentEndpoint;
const getContactDetailsCheckEndpoint = (locale, brand) => {
    return getContentEndpoint(locale, brand, "contact-details-check");
};
exports.getContactDetailsCheckEndpoint = getContactDetailsCheckEndpoint;
const getOtherBrandsAvailableModal = (locale, brand) => {
    return getContentEndpoint(locale, brand, "other-brands-available-modal");
};
exports.getOtherBrandsAvailableModal = getOtherBrandsAvailableModal;
//# sourceMappingURL=endpoints.js.map